import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import { RequireAuth } from './Auth/RequireAuth';
import NotFound from './NotFound';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Outlet/>,
    children: [
      {
        path: '/login',
        lazy: () => import("./Auth/Login").then(m => ({ Component: m.default })),
      },
      {
        path: '/',
        element: <RequireAuth />,
        children: [
          {
            path: '/',
            lazy: () => import("./Layout").then(m => ({ Component: m.Layout })),
            children: [
              {
                index: true,
                element: <Navigate to="/dashboard" replace />,
              },
              {
                path: 'dashboard',
                lazy: () => import("./Dashboard").then(m => ({ Component: m.default })),
              },
              {
                path: 'vendors',
                lazy: () => import("./Vendors").then(m => ({ Component: m.default })),
              },
              {
                path: 'repairers',
                lazy: () => import("./Repairers").then(m => ({ Component: m.default })),
              },
              {
                path: 'users',
                lazy: () => import("./Users").then(m => ({ Component: m.default })),
              },
              {
                path: 'users/:id',
                lazy: () => import("./Users/UserDetails").then(m => ({ Component: m.default })),
              },
              {
                path: 'contracts',
                lazy: () => import("./Contracts").then(m => ({ Component: m.default })),
              },
              {
                path: 'savs',
                lazy: () => import("./Savs").then(m => ({ Component: m.default })),
              },
              {
                path: 'plv',
                lazy: () => import("./Plv").then(m => ({ Component: m.default })),
              },
              {
                path: 'savs/v2/:id',
                lazy: () => import("./Savs/SavV2Details").then(m => ({ Component: m.default })),
              },
              {
                path: 'webhooks',
                lazy: () => import("./Webhooks").then(m => ({ Component: m.default })),
              },
              {
                path: 'webhooks/:uuid',
                lazy: () => import("./Webhooks/WebhookDetails").then(m => ({ Component: m.default })),
              },
            ],
          },
        ]
      }
    ],
  },

  {
    path: '*',
    element: <NotFound />,
  }
]);

export default router;